export default(() => {
    const element = document.querySelectorAll('.quiz-check-validation-message');
    const quizForm = document.querySelector('form.js-quiz');
    const quizButton = document.querySelector('.js-quiz .btn');
    if (quizButton) {
        quizButton.addEventListener('click', () => {
            const validated = [];
            const validatedInputs = Array.from(document.querySelectorAll('.js-radiobutton-validation-flag'));
            validatedInputs.forEach((validatedInput) => {
                validated.push(validatedInput.checked);
            });
            if (validated.includes(false)) {
                element.item(0).classList.add('active');
            } else {
                element.item(0).classList.remove('active');
                const quizAnswers = Array.from(document.querySelectorAll('.quiz-question .quiz-question__option input:checked'));
                const answersArray = quizAnswers.map(inputElement => inputElement.dataset.index);
                quizForm.insertAdjacentHTML('beforeend', `<input name="answers" type="hidden" value="${answersArray}">`);
                quizForm.submit();
            }
        });
    }
})();
